// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lZXp","left":"styles_left__166_S","desktopActions":"styles_desktopActions__3zR6Q","title":"styles_title__3lrlw"};